var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgReclassifyMerge = function SvgReclassifyMerge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#reclassify-merge_svg__clip0_5870_55640)",
    fill: "#666"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.317 10a2.5 2.5 0 001.517.513h3.334a4.168 4.168 0 014.105 3.455 2.5 2.5 0 11-1.693.053 2.5 2.5 0 00-2.412-1.841H8.834a4.148 4.148 0 01-2.5-.834v2.642a2.501 2.501 0 11-1.666 0V10h2.649zM6.09 16.936a.833.833 0 11-1.178-1.179.833.833 0 011.178 1.179zm10 0a.833.833 0 11-1.178-1.179.833.833 0 011.178 1.179z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.625 2.083a3.542 3.542 0 013.542 3.542v3.542H5.625a3.542 3.542 0 110-7.084zM7.5 7.5V5.625A1.875 1.875 0 105.625 7.5H7.5zm6.875-5.417a3.542 3.542 0 110 7.084h-3.542V5.625a3.542 3.542 0 013.542-3.542zm0 5.417A1.875 1.875 0 1012.5 5.625V7.5h1.875z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "reclassify-merge_svg__clip0_5870_55640"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgReclassifyMerge;